<div class="ui segment">
  <fui-dimmer [(isDimmed)]="segmentDimmed" [isClickable]="isClickable">
    <h4 class="ui fw-500 header">
      This is screen is not available for online checkout
    </h4>
  </fui-dimmer>
  <div class="ui basic segment">
    <div class="ui grid">
      <div
        class="
          left
          floated
          ten-wide-mobile
          eight-wide-tablet eight-wide-computer
          column
        "
      >
        <h2 class="ui header">₹{{ screenPrice }} /Sec</h2>
      </div>
      <div
        class="
          right
          floated
          right
          aligned
          six-wide-mobile
          eight-wide-tablet eight-wide-computer
          column
        "
      >
        <i class="yellow star icon"></i>
        4.9(98)
      </div>
    </div>
  </div>
  <div class="ui segment">
    <div class="ui divided two column grid">
      <div class="row">
        <div class="column">
          <label>Start Date</label>
          <div class="ui transparent input">
            <input
              fuiDatepicker
              [pickerUseNativeOnMobile]="false"
              type="text"
              placeholder="Start Date"
              disabled
            />
          </div>
        </div>
        <div class="column">
          <label>End Date</label>
          <div class="ui transparent input">
            <input
              fuiDatepicker
              [pickerUseNativeOnMobile]="false"
              type="text"
              placeholder="Start Date"
              disabled
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="ui segment">
    <div class="ui two column grid">
      <div class="row">
        <div class="column">
          <ng-container [ngSwitch]="isUserSignedIn">
            <ng-container *ngSwitchCase="false">
              <label>Ad Duration</label>
              <div class="ui transparent fluid input">
                <input
                  type="number"
                  placeholder="Ad Duration in Seconds"
                  disabled
                />
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="true">
              <label>Select you ad</label>
              <div class="ui transparent fluid input" disabled>
                <fui-select placeholder="Choose">
                  <fui-select-option value="Option 1"></fui-select-option>
                  <fui-select-option value="Option 2"></fui-select-option>
                  <fui-select-option value="Option 3"></fui-select-option>
                  <fui-select-option value="Option 4"></fui-select-option>
                </fui-select>
              </div>
            </ng-container>
          </ng-container>
        </div>
        <div class="column">
          <button
            routerLink="/ads"
            title="Upload Ad"
            class="ui circular primary button"
            disabled
          >
            <i class="arrow up icon"></i>
            Upload Ad
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="ui segment">
    <div class="ui divided two column grid">
      <div class="row">
        <div class="column">
          <label>Impression Count</label>
          <div class="ui transparent fluid input">
            <input type="number" placeholder="Total Impressions" />
          </div>
        </div>
        <div class="column">
          <label>Ad Intervel</label>
          <div class="ui transparent fluid input">
            <input type="number" placeholder="Total Impressions" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="ui basic fitted vertically segment">
    <div class="ui grid">
      <div class="left floated eight-wide column">
        <div class="ui large list">
          <div class="item">Price: ₹{{ screenPrice }} /Sec</div>
        </div>
      </div>
      <div class="right floated right aligned eight-wide column">
        <div class="ui large list">
          <div class="item">₹{{ screenPrice }}</div>
        </div>
      </div>
    </div>
    <div class="ui grid">
      <div class="left floated eight-wide column">
        <div class="ui large list">
          <div class="item">GST Tax</div>
        </div>
      </div>
      <div class="right floated right aligned eight-wide column">
        <div class="ui large list">
          <div class="item">₹{{ taxAmount }}</div>
        </div>
      </div>
    </div>
    <div class="ui divider"></div>
    <div class="ui grid">
      <div class="left floated eight-wide column">
        <div class="ui large list">
          <div class="item">Total</div>
        </div>
      </div>
      <div class="right floated right aligned eight-wide column">
        <div class="ui large list">
          <div class="item">₹{{ totalPrice }}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="ui basic fitted horizontally segment">
    <button
      title="Book Screen"
      class="ui fluid primary big button"
      [class.disabled]="isScreenAvailableForBooking"
    >
      Book & Checkout
    </button>
    <div class="ui center aligned fitted vertically basic segment">
      <button
        title="Add to cart"
        class="ui primary tertiary button"
        [class.disabled]="isScreenAvailableForBooking"
      >
        <i class="share icon"></i>add to cart
      </button>
    </div>
    <div
      class="ui right aligned fitted vertically basic segment"
      *ngIf="isScreenAvailableForBooking"
    >
      <i
        class="circular exclamation icon yellow link"
        fuiPopup
        popupSize="tiny"
        popupText="This is screen is not available for online checkout"
      ></i>
    </div>
  </div>
</div>
<signgaze-price-calculator-container
  [screenPricePerSecond]="screenPrice"
></signgaze-price-calculator-container>
